<button
  [class.button--dashed]="type === 'dashed'"
  [class.button--light]="type === 'light'"
  [class.button--full-width]="fullWidth"
  [disabled]="isDisabled"
  [type]="isSubmit ? 'submit' : 'button'"
  class="button"
>
  <ng-content></ng-content>
  @if (type === "default") {
    <img alt="arrow right icon" src="assets/icons/arrow-right-light.svg" />
  }
  @if (type === "light") {
    <img alt="arrow right icon" src="assets/icons/arrow-right-purple.svg" />
  }
</button>
